import { Color } from "three"

let modeldata =
{
    "conway-machines": [
        {
            "item-no": "$1,560.07",
            "part-number": "VEM3558",
            "description": "General Purpose Motor - 3 ph, 2 hp, 1800 rpm,208-230/460 V, 56C Frame, TEFC (Totally Enclosed Fan Cooled) Enclosure, 60 Hz, Footless/C-Face Flange Mount, 1755 rpm Base RPM",
            "qty": "2",
            "link":"https://www.motion.com/products/sku/04175919;origin=sayt",
            "bullet":[  "Ball bearings with a locked drive end bearing and heavy-gauge steel or cast iron frame",
            "VEM Super-E®/XE motors have NEMA Premium® efficiency",
            "Three-year warranty"

            ],
            "img":"https://www.motion.com/cdn-cgi/image/fit=scale-down,onerror=redirect,anim=false,quality=75,format=auto,metadata=none,width=554/motion3/fsdb/images/item/Baldor_A000359.jpg",
            "hex": "#A50000",
            "rgb": "Mesh116",
            "group": []
        },

        {
            "item-no": "This product requires a Quote request.",
            "part-number": "AJF-1800EP",
            "description": "Telesteps® Adjustable Feet- Ladders - Telesteps® 1800EP Models",
            "qty": "8",
            "link":"https://www.motion.com/products/sku/06728445",
            "bullet":[  "AJF-1800EP ADJUSTABLE FOOT FOR 1800EP","Soft rubber foot for interior surfaces.","Allows manual height adjustment of ladder legs for uneven surfaces"
            

            ],
            "img":"https://www.motion.com/cdn-cgi/image/fit=scale-down,onerror=redirect,anim=false,quality=75,format=auto,metadata=none,width=554/motion3/fsdb/images/item/Regal_Ideas_AJF-1600E.jpg",
            "hex": "#FF0000",
            "rgb": "Mesh245",
            "group": []
        },

        // {
        //     "item-no": "$473.44",
        //     "part-number": "89S WALL GUARD-STAINLESS",
        //     "description": "Wall Guard, Brushed Stainless Steel",
        //     "qty": "2",
        //     "link":"https://www.motion.com/products/sku/08676376",
        //     "bullet":[  "89S WALL GUARD-STAINLESS"


        //     ],
        //     "img":"https://www.motion.com/cdn-cgi/image/fit=scale-down,onerror=redirect,anim=false,quality=75,format=auto,metadata=none,width=554/motion3/fsdb/images/item/Excel_WallGuard_Stainless_Front.jpg",
        //     "hex": "#FF3F00",
        //     "rgb": "zid",
        //     "group": []
        // },
		

        {
            "item-no": "This product requires a Quote request.",
            "part-number": "VG-ARB-SS34-BB-6-5",
            "description": "Roll-Tech Mini Conveyor Without Side Guides - 6.00 in Roller Width, 5.00 ft Section Length, Stainless Steel Rollers, .750 in Roller Diameter",
            "qty": "1",
            "link":"https://www.motion.com/products/sku/06902164",
            "bullet":[  "Fully Assembled & Ready to Mount. ",
            "Without Side Guides.",
            "Smooth, Quiet Ball Bearing Roller Ends. "

            ],
            "img":"https://www.motion.com/cdn-cgi/image/fit=scale-down,onerror=redirect,anim=false,quality=75,format=auto,metadata=none,width=554/motion3/fsdb/images/item/System_Plast_Mini_Conveyor_Without_Rails.jpg",
            "hex": "#FF7F00",
            "rgb": "roleri",
            "group": []
        },
		
		
		// {
        //     "item-no": "$58.80",
        //     "part-number": "AF40-N04BD-Z-A",
        //     "description": "FILTER",
        //     "qty": "1",
        //     "link":"https://www.motion.com/products/sku/05624365",
        //     "bullet":[  "AF40-N04BD-Z-A",


        //     ],
        //     "img":"https://www.motion.com/cdn-cgi/image/fit=scale-down,onerror=redirect,anim=false,quality=75,format=auto,metadata=none,width=554/motion3/fsdb/images/item/SMC-Backbone_AF_A.jpg",
        //     "hex": "#FF3F00",
        //     "rgb": "zid",
        //     "group": []
        // },
		
		
		{
            "item-no": "$28.00",
            "part-number": "02PB03X51S",
            "description": "Albion Swivel Plate Wheeled Caster - 02 Series, Polypropylene Wheel Material, 3-1/2 in Wheel Diameter, 1-1/4 in Face Width, 275 lbs Load Capacity",
            "qty": "4",
            "link":"https://www.motion.com/products/sku/02540440",
            "bullet":[  "Top plate and yoke are heavily embossed, formed steel to extend caster life under rugged conditions",
			"Swivel section with heat-treated double ball bearing raceways to resist wear and improve maneuverability",
            "Kingpin: 1/2'' hydraulically formed steel rivet"


            ],
            "img":"https://www.motion.com/cdn-cgi/image/fit=scale-down,onerror=redirect,anim=false,quality=75,format=auto,metadata=none,width=554/motion3/fsdb/images/item/ALBION_INDUSTRIES_01330254.jpg",
            "hex": "#FF3F00",
            "rgb": "Mesh012",
            "group": []
        },
       

        
    ]
}


//     "envMap": [
//         {
//             "path": '/textures/Studio1/',
//             "sideOfMap":['px','nx','py','ny','pz','nz'],
//             "type":".png"

           

//         }

//     ]
// }
export {modeldata}
// const axios = require('axios');

// const hubspotApiKey = 'YOUR_API_KEY_HERE';
// const portalId = 'YOUR_PORTAL_ID_HERE';

// const apiUrl = `https://api.hubapi.com/contacts/v1/contact/?hapikey=${hubspotApiKey}&portalId=${portalId}`;

// const requestData = {
//   properties: [
//     {
//       property: 'firstname',
//       value: 'John',
//     },
//     {
//       property: 'lastname',
//       value: 'Doe',
//     },
//     // Add additional properties as needed
//   ],
//   path: [
//     {
//       pth: 'models/FlightHelmet/glTF/',
//       model: 'conway_materijali (1)',
//       typ: '.glb',
//     },
//     // Add additional path objects as needed
//   ],
// };

// axios.post(apiUrl, requestData)
//   .then(response => {
//     // Handle successful response
//     console.log(response.data);
//   })
//   .catch(error => {
//     // Handle error response
//     console.error(error);
//   });